import { useState, useEffect } from 'react';

const MOBILE_BREAKPOINT = 768;

export function useNarrowScreen(): boolean {
  const [isNarrow, setIsNarrow] = useState(
    () => window.innerWidth < MOBILE_BREAKPOINT
  );

  useEffect(() => {
    const handleResize = () => {
      setIsNarrow(window.innerWidth < MOBILE_BREAKPOINT);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isNarrow;
}
